export const SERVER_URL = 'https://vibes-media-server.onrender.com'
// export const SERVER_URL = 'http://localhost:3001'
